import React from 'react';
import PropTypes from 'prop-types';

import { Permissions } from '@src/global/permissions';

import { styled } from '@mui/material/styles';
import {
    DateInput,
    TextField,
    useRecordContext,
    Labeled,
} from 'react-admin';

import Moment from 'moment';

const StyledLabeled = styled(Labeled)({
    paddingTop: '6px',
    paddingBottom: 0,
});

const StyledTextField = styled(TextField)({
    top: '-8px',
    position: 'relative',
    fontSize: '1em',
});

const PublicationDateInput = (props) => {
    const { source, resource } = props;
    const record = useRecordContext();

    if (Permissions(resource, 'set_published') === false) {
        if (record && record.published_at) {
            return (
                <StyledLabeled filled="true" label="Publication Date">
                    <StyledTextField
                        source={source.publishedAt}
                    />
                </StyledLabeled>
            );
        }

        return null;
    }

    return (
        <DateInput
            required
            label="Publication Date"
            source={source.publishedAt}
            parse={(v) => Moment(v).toISOString()}
        />
    );
};

PublicationDateInput.propTypes = {
    resource: PropTypes.string,
    source: PropTypes.object,
};

export default PublicationDateInput;
